// @ts-nocheck
import { searchBoxStyles } from "@insite/content-library/Widgets/MyLists/MyListsSearchBox";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Search from "@toolkit/Library/Components/Icons/Search";
import { css } from "styled-components";

Object.assign(searchBoxStyles, {
    search: {
        css: css`
            padding: 0 2.5em 0 ${pxToRem(10)};
        `,
        iconProps: { src: Search, height: 24, width: 24, color: "primary" },
        cssOverrides: {
            inputSelect: css`
                padding: 0 2.5em 0 ${pxToRem(10)};

                &:focus,
                &:active {
                    padding: 0 2.5em 0 ${pxToRem(10)};
                    border-color: ${getColor("primary")};
                }
            `,
        },
    },
});
